class RoutesPath {
    static HOME = { NAME: 'Home', PATH: '/' };

    static EXAMPLE_PAGE = { NAME: 'Example Page', PATH: '/example' };
}

export default RoutesPath;
